import { useContext, useEffect, useState } from 'react';
import { Field } from 'formik';
import { Switch } from '../../../../common/formik';
import { Grid, Card, CardContent, CardHeader } from '@material-ui/core';
import { Select, FieldError } from '../../../../common';
import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { SettingsContext } from '../../../../contexts/SettingsContext';
import { SapTableNames } from '../../../../../helpers';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
}));

export const LogisticsPlanningForm = (props) => {
    const classes: any = useStyles();

    const {
        state,
        getTableOptionsWithCode
    } = useContext(CustomerRequestContext);

    const {
        values
    } = useContext(TabsContext);

    const {
        appSettingsS4,
        appSettingsECC
    } = useContext(SettingsContext);

    const [isPerfume, setIsPerfume] = useState(false);

    useEffect(() => {
        if (values !== null && appSettingsECC !== null) {
            const perfumeBC = appSettingsECC.find(x => x.appSettingKey === "PerfumesBusinessCategoryId");

            if (perfumeBC && Number(perfumeBC.value) === values.businessCategoryId)
                setIsPerfume(true);
        }
    }, [values, appSettingsECC]);

    useEffect(() => {
        if (values !== null && appSettingsS4 !== null) {
            const perfumeBC = appSettingsS4.find(x => x.appSettingKey === "PerfumesBusinessCategoryId");

            if (perfumeBC && Number(perfumeBC.value) === values.businessCategoryId)
                setIsPerfume(true);
        }
    }, [values, appSettingsS4]);

    return (
        <Card className={classes.card}>
            <CardHeader title="Distribution planning" />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={12} md={12} xs={12}>
                        <Select
                            name="logisticPlanning.deliveryPriorityId"
                            label="Delivery priority *"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.DeliveryPriorities, values.dbType)}
                        />
                        <FieldError name="logisticPlanning.deliveryPriorityId" errors={state.errors} />
                    </Grid>
                    {/*removed this field because the customers don't want it anymore (21/10/2020)
                    <Grid item xl={12} md={12} xs={12}>
                        <Select
                            name="logisticPlanning.requestedDeliveryDateId"
                            label="Requested delivery date compulsory *"   
                            disabled={props.disabled}
                            options={getTableOptions(SapTableNames.RequestedDeliveryDateMandatory)}
                        />
                        <FieldError name="logisticPlanning.requestedDeliveryDateId" errors={state.errors} />
                    </Grid>*/}

                    {
                        !values.isLogisticsJWA &&
                        <Grid item xl={12} md={12} xs={12}>
                            <Field
                                label="Does the customer accept back orders?"
                                name="logisticPlanning.acceptBackOrders"
                                disabled={props.disabled}
                                component={Switch}
                            />
                            <FieldError name="logisticPlanning.acceptBackOrders" errors={state.errors} />
                        </Grid>
                    }
                    {
                        isPerfume &&
                        <Grid item xl={12} md={12} xs={12}>
                            <Select
                                name="logisticPlanning.cG4Id"
                                label="CG4 *"
                                disabled={props.disabled}
                                options={getTableOptionsWithCode(SapTableNames.CG4, values.dbType)}
                            />
                            <FieldError name="logisticPlanning.CG4Id" errors={state.errors} />
                        </Grid>
                    }
                </Grid>
            </CardContent>
        </Card>
    );
};